import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from "recharts";

const STATUS_COLORS = {
  active: "#059669",
  trial: "#2563eb",
  inactive: "#94a3b8",
  suspended: "#ef4444",
};

/**
 * InstituteStatusChart — Donut chart showing institute distribution by status.
 */
const InstituteStatusChart = ({ data = [] }) => {
  const total = data.reduce((s, d) => s + d.count, 0);

  if (total === 0) {
    return (
      <div className="sa-card">
        <div className="sa-card-head">
          <div className="sa-card-title">Institute Status</div>
        </div>
        <div className="sa-card-body"><div className="sa-empty">No data</div></div>
      </div>
    );
  }

  const chartData = data.map((d) => ({
    name: d.status,
    value: d.count,
    color: STATUS_COLORS[d.status] || "#94a3b8",
  }));

  return (
    <div className="sa-card">
      <div className="sa-card-head">
        <div className="sa-card-title">Institute Status</div>
      </div>
      <div className="sa-card-body">
        <div className="sa-donut-wrapper">
          <ResponsiveContainer width="100%" height={180}>
            <PieChart>
              <Pie
                data={chartData}
                dataKey="value"
                cx="50%"
                cy="50%"
                innerRadius={50}
                outerRadius={72}
                paddingAngle={3}
                stroke="none"
              >
                {chartData.map((d, i) => (
                  <Cell key={i} fill={d.color} />
                ))}
              </Pie>
              <Tooltip
                formatter={(value, name) => [`${value} institutes`, name]}
                contentStyle={{
                  fontSize: "12px",
                  borderRadius: "8px",
                  border: "1px solid var(--border-primary)",
                  background: "var(--card-bg)",
                }}
              />
            </PieChart>
          </ResponsiveContainer>
          <div className="sa-donut-center">
            <span className="sa-donut-center__value">{total}</span>
            <span className="sa-donut-center__label">Total</span>
          </div>
        </div>
        <div className="sa-chart-legend">
          {chartData.map((d) => (
            <div key={d.name} className="sa-chart-legend__item">
              <span className="sa-chart-legend__dot" style={{ background: d.color }} />
              <span className="sa-chart-legend__label">{d.name}</span>
              <span className="sa-chart-legend__count">{d.value}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default InstituteStatusChart;
